import { PayPalMessageContainer } from './PayPalMessage.styles'
import type { PayPalMessageProps } from './PayPalMessage.types'

export const PayPalMessage = ({
  amount,
  placement,
  className = '',
}: PayPalMessageProps): JSX.Element | null => {
  if (!Number.isFinite(amount) || amount < 1) {
    return null
  }

  return (
    <PayPalMessageContainer
      className={className}
      data-pp-message=""
      data-pp-placement={placement}
      data-pp-amount={(amount / 100).toFixed(2)}
      data-pp-style-layout="text"
      data-pp-style-logo-type="inline"
    />
  )
}
